/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

const imageRegexp = /^!\[([^\]]*)]\s*\(([^)"]+)( "([^)"]+)")?\s*\)/;
let oldRule = undefined;
let rule = (state, silent) => {
  if (!state.src) {
    return false;
  }
  const pos = state.pos;
  if (state.src[pos] !== '!') {
    return oldRule?.(state, silent);
  }
  const match = imageRegexp.exec(state.src.slice(pos));
  if (!match) {
    return false;
  }
  if (!silent) {
    const openToken = {
      type: "image_open",
      content: {
        src: match[2],
        alt: match[1]
      },
      level: state.level
    };
    state.push(openToken);
    const spaceToken = {
      type: "text",
      content: "\u200b",
      // hack: this is a zero-width space, but I need a place for markdown-to-draft to hang the entity
      level: state.level + 1
    };
    state.push(spaceToken);
    const closeToken = {
      type: "image_close",
      level: state.level
    };
    state.push(closeToken);
    state.pos += match[0].length;
  }
  return true;
};

// const imageRule: Remarkable.Rule<ImageToken, string> = (tokens: ImageToken[],
//                                                         idx: number): string => {
//
//   const imageToken = tokens[0];
//   return `<img src="${imageToken.src}" alt="${imageToken.alt}">`;
// }

export function abMarkdownImagePlugin(remarkable) {
  // Remarkable inline has a rule named "links" that handles "!(foo)[bar]" and "(foo)[bar]".
  // Instead of it emitting Remarkable.imageToken, we want our triple.
  // If it
  if (!oldRule) {
    let oldRules = remarkable.inline.ruler.__rules__;
    let foundLinksRule = oldRules.find(rule => rule.name === "links");
    if (foundLinksRule) {
      oldRule = foundLinksRule.fn;
    }
  }

  // converts Markdown image link text to a tripe of tokens: image_open, space, image_closed.
  // This is so I can get markdown-to-draft to behave.
  remarkable.inline.ruler.at("links", rule, {});
}
//# sourceMappingURL=AbMarkdownImagePlugin.js.map
